import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // Importez Link de react-router-dom
import "./MyExams.css"; // Vous pouvez styliser ici

const HomePage = () => {
  const [examens, setExamens] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    const fetchExamens = async () => {
      const token = localStorage.getItem("token");
      const tenantId = localStorage.getItem("tenantId"); 
      if (!token) {
        console.error("Token non trouvé dans le stockage local.");
        return;
      }

      try {
        const response = await axios.get(process.env.REACT_APP_EUREKA_PACS_URL+"/api/examens", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
             "X-Tenant-Id": String(tenantId),
          },
        });
        setExamens(response.data);
      } catch (error) {
        console.error("Erreur :", error);
      }
    };

    fetchExamens();
  }, []);

  const handleSort = (column) => {
    const direction =
      sortedColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortedColumn(column);
    setSortDirection(direction);

    const sortedData = [...examens].sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (valueA < valueB) return direction === "asc" ? -1 : 1;
      if (valueA > valueB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setExamens(sortedData);
  };

  const filteredExamens = examens.filter((examen) => {
    const fullText = Object.values(examen)
      .flatMap((value) => {
        if (value && typeof value === "object") {
          return Object.values(value).flatMap((nestedValue) =>
            nestedValue && typeof nestedValue === "object"
              ? Object.values(nestedValue)
              : nestedValue
          );
        }
        return value;
      })
      .join(" ")
      .toLowerCase();

    return fullText.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="home-container">
      {/* Bouton de retour à la page d'accueil */}
      <Link to="/accueil" className="btn-home">
        <i className="fas fa-home"></i> Retour à l'Accueil
      </Link>

      <h1>Mes Examens</h1>
      <input
        type="text"
        placeholder="Rechercher..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      <table className="examens-table">
        <thead>
          <tr>
            <th onClick={() => handleSort("id")}>
              ID {sortedColumn === "id" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th onClick={() => handleSort("nom")}>
              Nom {sortedColumn === "nom" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th>Patient</th>
            <th>Date Examen</th>
            <th>Radiologue</th>
            <th>Technicien</th>
            <th>Voir Détails</th>
          </tr>
        </thead>
        <tbody>
          {filteredExamens.map((examen) => (
            <tr key={examen.id}>
              <td>{examen.id}</td>
              <td>{examen.nom}</td>
              <td>{examen.patient.personne?.nom || ""} {examen.patient.personne?.prenom || ""}</td>
              <td>{examen.created_at ? new Date(examen.created_at).toLocaleDateString() : ""}</td>
              <td>{examen.radiologue?.personne?.nom || ""} {examen.radiologue?.personne?.prenom || ""}</td>
              <td>{examen.technicien?.personne?.nom || ""} {examen.technicien?.personne?.prenom || ""}</td>
              <td>
                <Link to={`/examens/${examen.publicId}`} className="btn-details">
                  Voir Détails
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HomePage;
